import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { INavigationElement as INavigationElement } from './INavigationElement';

@Component({
    animations: [
        trigger('fadeIn', [
            transition(':enter', [
                style({ opacity: 0, height: 0 }),
                animate(300),
            ]),
        ])
    ],
    selector: 'app-navigation-bar',
    styleUrls: ['./navigation-bar.component.scss'],
    templateUrl: './navigation-bar.component.html',
    standalone: false
})
export class NavigationBarComponent implements OnInit {

  @Input() public elements: INavigationElement[];
  @Input() public currentIndex: string;
  @Input() public fade: boolean;

  constructor() { }

  public ngOnInit() {
  }

  public get currentArrayIndex(): number {
    const i = this.getIndexArray().indexOf(this.currentIndex);
    return i >= 0 ? i : Number.MAX_SAFE_INTEGER;
  }

  public moveToNextIndex(): string {
    const i = this.currentArrayIndex;
    const next = this.getIndexArray()[i + 1];
    this.currentIndex = next;
    return next;
  }

  public moveToPreviousIndex(): string {
    const i = this.currentArrayIndex;
    const previous = this.getIndexArray()[i - 1];
    this.currentIndex = previous;
    return previous;
  }

  public hasNext(): boolean {
    return this.hasElement(1);
  }

  public hasPrevious(): boolean {
    return this.hasElement(-1);
  }

  private hasElement(diff: number): boolean {
    const i = this.currentArrayIndex;
    return i >= 0 && Boolean(this.elements[i + diff]);
  }

  private getIndexArray(): string[] {
    return this.elements.map((elem: INavigationElement) => elem.index);
  }
}
